import React from 'react';
import { Link } from 'react-router-dom';
import { cn } from '../../utils/cn';

interface AuthCardProps {
  label?: string;
  labelColor?: 'primary' | 'secondary' | 'success';
  title: string;
  subtitle?: string;
  children: React.ReactNode;
  footer?: {
    text: string;
    linkText: string;
    href: string;
  };
  className?: string;
}

const labelColors = {
  primary: 'bg-primary/10 text-primary border border-primary/20',
  secondary: 'bg-secondary/10 text-secondary border border-secondary/20',
  success: 'bg-success/10 text-success border border-success/20',
};

export const AuthCard: React.FC<AuthCardProps> = ({
  label,
  labelColor = 'primary',
  title,
  subtitle,
  children,
  footer,
  className,
}) => {
  return (
    <div
      className={cn(
        'w-full max-w-md rounded-[30px] border border-primary/10 bg-white p-8 shadow-surface',
        className
      )}
    >
      {/* Label */}
      {label && (
        <div className={cn('inline-block px-3 py-1 rounded-full text-sm font-medium mb-4', labelColors[labelColor])}>
          {label}
        </div>
      )}

      {/* Title */}
      <h2 className="text-2xl font-bold text-ink mb-2">
        {title}
      </h2>

      {/* Subtitle */}
      {subtitle && (
        <p className="text-slate-600 mb-6">
          {subtitle}
        </p>
      )}

      {/* Content */}
      <div className="space-y-6">
        {children}
      </div>

      {/* Footer Link */}
      {footer && (
        <div className="mt-6 border-t border-primary/10 pt-6 text-center text-sm text-slate-600">
          {footer.text}{' '}
          <Link 
            to={footer.href} 
            className="text-primary font-semibold hover:underline"
          >
            {footer.linkText}
          </Link>
        </div>
      )}
    </div>
  );
};

export default AuthCard;
